// 下記を参考に作成

import Axios from "axios";

// https://www.hands-lab.com/tech/entry/5172.html
export const checkIfApplicationUpdated = async (): Promise<boolean> => {
    // TM-9306 U2 BR-U2-1: 接続先と稼働系が食い違っていれば再読み込みを促す。
    // 配信物の確認より前に置く必要がある（下の localhost 判定で抜けると ito 環境で動かないため）
    if (await isActiveModeMismatched()) {
        return true;
    }

    const host = location.host;

    // ローカル実行時はindex.html取得不可
    if (host.indexOf("localhost") == 0) {
        return false;
    }
    const path = location.pathname;

    // その他含めて共通
    const url = `https://${host}${path}`;
    return await Axios.get(url)
        .then((res) => {
            const html = res?.data ?? "";
            const hash = createHash(html);
            return isHashChanged(hash);
        })
        .catch((e) => {
            console.warn("[checkIfApplicationUpdated] Error", e);
            if (!e.response) {
                // ネットワークエラーは無視する
                return false;
            }
            // throw e;
        });
};

// TM-9306 U2: 画面の接続先（api）と稼働系（s3）を照合する。
// BR-U2-5: 毎回その時点の値を見る必要があるため、応答が使い回されないようにする
export async function isActiveModeMismatched(): Promise<boolean> {
    try {
        const res = await Axios.get(`${import.meta.env.VITE_APP_API_BASE}v1/auth/mode`, {
            params: { _: Date.now() },
        });
        const api = res?.data?.api ?? "";
        const s3 = res?.data?.s3 ?? "";
        // BR-U2-3: 稼働系が判定できないときは促さない（判定不能は食い違いではない）
        if (!api || !s3 || s3 === "unknown") {
            return false;
        }
        return api !== s3;
    } catch (e) {
        // BR-U2-4: 照合そのものに失敗したときは促さない（再読み込みしても解消しないため）
        console.warn("[isActiveModeMismatched] Error", e);
        return false;
    }
}

function createHash(str) {
    const len = str.length;
    let hash = 0;
    if (len === 0) return hash;
    let i;
    for (i = 0; i < len; i++) {
        hash = (hash << 5) - hash + str.charCodeAt(i);
        hash |= 0;
    }
    return hash;
}

let previousHash = 0;
function isHashChanged(hash: number): boolean {
    if (previousHash === 0) {
        previousHash = hash;
        return false;
    }
    return previousHash !== hash;
}
